// console.log('javascript loaded ready ...');

// restore $ variable to jQuery (which effectively deactivates noConflict mode)
var $ = jQuery.noConflict();

jQuery(document).ready(function($){
    $('h2.togglers').click(function(e){ // change toggle
        $('h2.togglers').removeClass('active');
        $(this).addClass('active');

        $(this).next().slideDown();
        $("div.elements").not($(this).next()).slideUp();
        e.preventDefault();
    });
    // close elements
    if($('h2.togglers').length){
        $('div.elements').css('display', 'none');
    }

    // first toggler open
    $('h2.togglers').first().addClass('active');
    $('div.elements').first().css('display', 'block');

    // clone search into mobile nav
    if($('li.widget_search').length) {
        var search = $('li.widget_search').html();
        $('nav.header__nav>ul').append('<li class="nav__item nav__item--level1 widget_search">' + search + '</li>');
    }

    // Sticky Sidebar
    $('.main-content, .sidebar-content').theiaStickySidebar({
        // Settings
        additionalMarginTop: 40,
        disableOnResponsiveLayouts: true
    });

    // Search form placeholder
    $(".searchform #s").attr("placeholder", "zoek hier...");
    $(".searchform #s").attr("autocomplete", "off");

});